import React from 'react';
import Alert from '../components/Alert';

const DecommissionInfo = () => {
  return (
    <Alert>
      Z dôvodu nízkeho počtu ľudí v čakárni dňom 06.03.2022 tento web prestane
      zbierať nové dáta (staré dáta budú stále k dispozícii). Ak by sa počty v
      čakárni zvýšili tak web znova obnovím. Vďaka za podporu.
    </Alert>
  );
};

export default DecommissionInfo;
